import { Form, Select } from 'antd';
import CountryRegionData from 'country-region-data/data.json';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

const options = CountryRegionData || [];

const CountrySelect = ({ ...props }) => {
  const { t } = useTranslation('common');
  const countries = options.map((e) => ({ value: e.countryShortCode, label: e.countryName }));
  
  return (<Select
    showSearch
    filterOption={true}
    allowClear={true}
    {...props}
    placeholder={t('selectPlaceholder')}
    optionFilterProp={'label'}
    options={countries}>
  </Select>);
  
};

CountrySelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func
};

CountrySelect.defaultProps = {};

export default memo(CountrySelect);

export const renderCountrySelect = ({ formItemProps, field }) => {
  return (
    <Form.Item {...formItemProps} required={field?.required}>
      <CountrySelect {...field?.widgetProps} {...field}/>
    </Form.Item>
  );
};

renderCountrySelect.propTypes = {
  formItemProps: PropTypes.object,
  field: PropTypes.object,
  form: PropTypes.object,
};
